import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { FicheComplementaireSante } from '../../components/Souscriptions/models/FicheComplementaireSante.model';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class ComplementaireSanteService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'ComplementaireSante');
  }

  setFicheCompementaireSante(
    request: FicheComplementaireSante,
  ): Observable<any> {
    return this.put('/setFicheCompementaireSante', request);
  }
  getFicheCompementaireSante(
    guidUser: string,
    mdpUser: string,
  ): Observable<any> {
    return this.httpGetFicheCompementaireSante(
      '/getFicheCompementaireSante/' + guidUser + '/' + mdpUser,
    );
  }
}
